module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_100_250.439cad9e.png";